import React, { Suspense, lazy } from 'react';
import Loading from './Components/Loading';

// Lazy load your main content (for example, HomePage or other pages)
const HomePage = lazy(() => import('./Pages/Homepage'));

const App = () => {
  return (
    <Suspense fallback={<Loading />}>
      {/* Your main content */}
      <HomePage />
    </Suspense>
  );
};

export default App;
